module.exports = __webpack_public_path__ + "img/logo.8f2e7aa5.png";